import { useTranslation } from 'react-i18next';

/**
 * Drafts of the legal documents. They describe what the service actually does
 * with data today; the operator's details and the final wording are to be
 * filled in, ideally with a lawyer, before the public launch.
 */
export function PrivacyPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t('legal.privacyTitle')}</h1>
      <p>
        <em>{t('legal.draft')}</em>
      </p>
      <h2>Какие данные мы обрабатываем</h2>
      <ul>
        <li>Адрес электронной почты, логин, имя (если вы его указали), выбранный аватар и язык.</li>
        <li>Колоды и карточки, которые вы создаёте.</li>
        <li>
          История повторений: когда и как вы ответили на карточку и сколько времени это заняло. По
          ней планировщик решает, когда показать карточку снова.
        </li>
        <li>Технические журналы запросов (адрес, время, код ответа) — для поиска ошибок.</li>
      </ul>
      <h2>Зачем</h2>
      <p>
        Чтобы вы могли войти в аккаунт, учить карточки и получать письма о подтверждении адреса и
        сбросе пароля.
      </p>
      <h2>Cookie</h2>
      <p>
        Используются только необходимые cookie: <code>session_id</code> — чтобы вы оставались в
        аккаунте, и <code>csrf_token</code> — чтобы защитить формы от подделки запросов.
        Аналитических и рекламных cookie нет.
      </p>
      <h2>Где хранятся данные</h2>
      <p>На серверах в Российской Федерации.</p>
      <h2>Ваши права</h2>
      <p>
        Вы можете узнать, какие данные о вас хранятся, исправить их или потребовать удаления
        аккаунта вместе со всеми данными. Контакт оператора будет указан в этом разделе.
      </p>
    </article>
  );
}

/** Draft terms of use. */
export function TermsPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t('legal.termsTitle')}</h1>
      <p>
        <em>{t('legal.draft')}</em>
      </p>
      <p>
        Сервис находится в разработке и предоставляется «как есть». Не загружайте в карточки
        материалы, на которые у вас нет прав, и чужие персональные данные.
      </p>
    </article>
  );
}
